import React, { FC } from 'react';

import { Text } from '@nerdwallet/currency/components/Text';
import { Stack } from '@nerdwallet/currency/components/Stack';
import { FormInput } from './form-builder/form-input';

const RentersInfoForm: FC = () => {
  return (
    <Stack spacing="3">
      <Text bold>Property information</Text>
      <FormInput field="zipCode" label="ZIP code" fullWidth />
    </Stack>
  );
};

export default RentersInfoForm;
